import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  .notification-settings {
    background: white;
    border-radius: var(--sl-border-radius-large);
    padding: 2rem;
    box-shadow: var(--sl-shadow-small);
  }

  .header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .header-icon {
    font-size: 2rem;
    color: var(--sl-color-primary-600);
  }

  .header-text h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--sl-color-neutral-900);
  }

  .header-text p {
    margin: 0.25rem 0 0 0;
    font-size: 0.875rem;
    color: var(--sl-color-neutral-600);
  }

  .setting-section {
    margin-bottom: 1.5rem;
  }

  .setting-section h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--sl-color-neutral-900);
  }

  .section-description {
    margin: 0 0 1rem 0;
    font-size: 0.875rem;
    color: var(--sl-color-neutral-600);
  }

  .master-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem;
    background: var(--sl-color-neutral-50);
    border-radius: var(--sl-border-radius-medium);
    border: 2px solid var(--sl-color-neutral-200);
  }

  .toggle-info h3 {
    margin: 0 0 0.25rem 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--sl-color-neutral-900);
  }

  .toggle-info p {
    margin: 0;
    font-size: 0.875rem;
    color: var(--sl-color-neutral-600);
  }

  .setting-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    border-radius: var(--sl-border-radius-medium);
    margin-bottom: 0.75rem;
    transition: background-color 0.2s;
  }

  .setting-item:hover {
    background: var(--sl-color-neutral-50);
  }

  .setting-info {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    flex: 1;
  }

  .setting-icon {
    font-size: 1.5rem;
    color: var(--sl-color-primary-600);
    margin-top: 0.25rem;
  }

  .setting-info h4 {
    margin: 0 0 0.25rem 0;
    font-size: 1rem;
    font-weight: 600;
    color: var(--sl-color-neutral-900);
  }

  .setting-info p {
    margin: 0;
    font-size: 0.875rem;
    color: var(--sl-color-neutral-600);
    line-height: 1.4;
  }

  .divider {
    height: 1px;
    background: var(--sl-color-neutral-200);
    margin: 2rem 0;
  }

  .test-section {
    display: flex;
    justify-content: center;
    padding: 1rem 0;
  }

  .info-box {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1rem;
    background: var(--sl-color-blue-50);
    border-left: 4px solid var(--sl-color-blue-600);
    border-radius: var(--sl-border-radius-medium);
    margin-top: 2rem;
    font-size: 0.875rem;
    color: var(--sl-color-neutral-700);
  }

  .info-box sl-icon {
    color: var(--sl-color-blue-600);
    font-size: 1.25rem;
    flex-shrink: 0;
    margin-top: 0.125rem;
  }

  /* Not supported / Permission denied states */
  .not-supported,
  .permission-denied {
    text-align: center;
    padding: 3rem 2rem;
    background: white;
    border-radius: var(--sl-border-radius-large);
    box-shadow: var(--sl-shadow-small);
  }

  .warning-icon {
    font-size: 4rem;
    color: var(--sl-color-warning-600);
    margin-bottom: 1rem;
  }

  .not-supported h3,
  .permission-denied h3 {
    margin: 0 0 1rem 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--sl-color-neutral-900);
  }

  .not-supported p,
  .permission-denied p {
    margin: 0 0 1rem 0;
    font-size: 1rem;
    color: var(--sl-color-neutral-600);
    line-height: 1.6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .permission-denied ol {
    text-align: left;
    max-width: 500px;
    margin: 1.5rem auto;
    padding-left: 1.5rem;
    color: var(--sl-color-neutral-700);
  }

  .permission-denied li {
    margin-bottom: 0.5rem;
    line-height: 1.6;
  }

  sl-alert {
    margin-bottom: 1.5rem;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .notification-settings {
      padding: 1.5rem;
    }

    .master-toggle {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }

    .setting-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }
  }
`;

